import React from "react";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { useUploadSysLog } from "Components/Topology/queries";

// { level, stateCid, loginCid, time_zone, export_all_log, record }

const SystemLog = () => {
  const { level, stateCid, loginCid, time_zone } = useAppSelector((state) => state.global);
  const { deviceRecord } = useAppSelector((state) => state.topology);
  const { t } = useTranslation();
  const { mutateAsync: UploadSysLog, isLoading, isSuccess } = useUploadSysLog(stateCid);

  const UploadLog = (export_all_log: boolean) => {
    UploadSysLog({ level, stateCid, loginCid, time_zone, export_all_log, deviceRecord })
      .then(() => message.success(t("ISMS.Success")))
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  return (
    <div className="mt-3">
      <h2 className="mb-2">{t("ISMS.Upload Log to File Repository")}</h2>
      <div>
        <Button loading={isLoading} type="primary" onClick={() => UploadLog(true)}>
          {t("ISMS.All Log")}
        </Button>
        <Button loading={isLoading} type="primary" onClick={() => UploadLog(false)} className="ml-1">
          {t("ISMS.SysLog only")}
        </Button>
      </div>
      {/* {isLoading && <p className="mt-1">{t("ISMS.Log is Uploading")}</p>}
      {isSuccess && <p className="mt-1">{t("ISMS.Upload Success")}</p>} */}
    </div>
  );
};

export default SystemLog;
